<template>
    <div class="waiting-list">
        <!--Heading-->
        <h3>{{ $t("waitingList.title") }}</h3>
        <div class="waiting-list-wrapper section-wrap">
            <!--Waiting List Enroll Content-->
            <div class="waiting-list-enroll">
                <!--Waiting List Enroll Heading-->
                <div class="waiting-list-enroll-heading" v-if="!loaded && enrollScreen !== 'enroll-step-four'">
                    <h5>
                        {{ $t("waitingListEnroll.waitList") }} - {{ $t("waitingListEnroll.just") }} ${{
                            enrollmentCost
                        }}/Month!
                    </h5>
                </div>
                <!--Waiting List Enroll Content-->
                <div class="waiting-list-enroll-content">
                    <!--Waiting List Enroll Info First Screen-->
                    <enroll-info-first-screen
                        @change-screen="changeScreen"
                        v-if="
                            enrollScreen === 'first-screen' &&
                            !loaded &&
                            !wlistSettingsLoaded &&
                            !getStylistProfileLoaded
                        "
                    >
                    </enroll-info-first-screen>
                    <!--Waiting List Enroll Info Secound Screen-->
                    <enroll-info-secound-screen @change-screen="changeScreen" v-if="enrollScreen === 'secound-screen'">
                    </enroll-info-secound-screen>
                    <!--Waiting List Enrollment Step One Screen-->
                    <enroll-step-one
                        @change-screen="changeScreen"
                        v-if="enrollScreen === 'enroll-step-one'"
                    ></enroll-step-one>
                    <!--Waiting List Enrollment Step Two Screen-->
                    <enroll-step-two
                        @change-screen="changeScreen"
                        v-if="enrollScreen === 'enroll-step-two'"
                    ></enroll-step-two>
                    <!--Waiting List Enrollment Step Three Screen-->
                    <enroll-step-three
                        @change-screen="changeScreen"
                        v-if="enrollScreen === 'enroll-step-three' && !loaded"
                    ></enroll-step-three>
                    <!--Waiting List Enrollment Step Four Screen-->
                    <enroll-congratulation
                        text="Congratulations! You’re all set up. <br> You’re ready to start using the Waitlist feature and streamline your schedule."
                        buttonText="Finish"
                        :goToDashboard="true"
                        v-if="enrollScreen === 'enroll-step-four'"
                    ></enroll-congratulation>
                    <!--Waiting List Loader-->
                    <main-loader v-if="loaded"></main-loader>
                    <main-loader v-if="wlistSettingsLoaded && getStylistProfileLoaded"></main-loader>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../services/vuex";
import eventBus from "../../../services/eventBus";
import EnrollInfoFirstScreen from "./parts/EnrollInfoFirstScreen.vue";
import EnrollInfoSecoundScreen from "./parts/EnrollInfoSecoundScreen.vue";
import EnrollStepOne from "./parts/EnrollStepOne.vue";
import EnrollStepTwo from "./parts/EnrollStepTwo.vue";
import EnrollStepThree from "./parts/EnrollStepThree.vue";
import EnrollCongratulation from "./parts/EnrollCongratulation.vue";
import MainLoader from "../general-components/MainLoader.vue";
import api from "../../../services/apiEndpoints";

export default {
    data() {
        return {
            enrollScreen: "",
            enrollmentCost: 1,
            profile: {},
            loaded: false,
            waitingListSettings: {},
            wlistSettingsLoaded: false,
            getStylistProfileLoaded: false,
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        this.enrollmentCost = import.meta.env["VITE_ENROLLMENT_COST"];

        this.loaded = true;
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.getStylistProfile();
        });

        if (this.adminDetails && this.adminDetails.profile) {
            this.getStylistProfile();
        }

        this.getWaitingListSubscriptionAndSettings();
        this.enrollScreen = "first-screen";
    },
    methods: {
        changeScreen(screen) {
            this.enrollScreen = screen;
        },
        getStylistProfile() {
            this.getStylistProfileLoaded = true;
            this.profile = this.adminDetails.profile;
            this.loaded = false;
            this.getStylistProfileLoaded = false;
        },
        getWaitingListSubscriptionAndSettings() {
            this.loading = true;
            this.wlistSettingsLoaded = true;
            this.$http.get(api.actions.get_waiting_list_subscription_and_settings).then((response) => {
                if (response.data.error == true) {
                    return;
                }
                this.waitingListSettings = response.data.waitlist_subscription_and_settings;
                this.loading = false;
                this.wlistSettingsLoaded = false;
            });
            return;
        },
    },
    components: {
        EnrollInfoFirstScreen,
        EnrollInfoSecoundScreen,
        EnrollStepOne,
        EnrollStepTwo,
        EnrollStepThree,
        EnrollCongratulation,
        MainLoader,
    },
};
</script>
